import { Controller, useFormContext, Control } from 'react-hook-form';
import { CustomSelect, ICustomSelect } from './Custom/CustomSelect';

interface IFormSelect extends ICustomSelect {
  control?: Control<any>;
  name: string;
  [x: string]: any;
}

export const FormSelect = (props: IFormSelect) => {
  const { control, ...restProps } = props;
  const methods = useFormContext();
  const _control = methods?.control || control;

  return _control ? (
    <Controller
      control={_control}
      name={restProps?.name}
      render={(renderProps) => {
        const {
          field,
          fieldState: { error },
        } = renderProps;
        const { ref, ...restFieldProps } = field;

        return <CustomSelect {...restProps} {...restFieldProps} error={error} />;
      }}
    />
  ) : (
    <CustomSelect {...restProps} />
  );
};
